export const typography = {
  family: {
    primary: 'Manrope',
    secondary: 'Manrope',
  },
  fontSize: {
    custom: {
      base: '14px',
      lg: '16px',
      sm: '12px',
      xl: '20px',
      xl2: '24px',
      xl3: '28px',
      xl4: '32px',
      xl5: '36px',
      xl6: '44px',
      xl7: '56px',
      xs: '11px',
    },
    global: {
      x10: '10px',
      x12: '12px',
      x14: '14px',
      x16: '16px',
      x18: '18px',
      x20: '20px',
      x22: '22px',
      x24: '24px',
      x26: '26px',
      x28: '28px',
      x30: '30px',
      x32: '32px',
      x34: '34px',
      x36: '36px',
      x38: '38px',
      x40: '40px',
      x42: '42px',
      x44: '44px',
    },
    text: {
      '2xl': '24px',
      '3xl': '30px',
      '4xl': '36px',
      '5xl': '48px',
      '6xl': '60px',
      '7xl': '72px',
      '8xl': '96px',
      '9xl': '128px',
      base: '16px',
      lg: '18px',
      sm: '14px',
      xl: '20px',
      xs: '12px',
    },
  },
  letterSpacing: {
    display: '0px',
    normal: '0px',
    tight: '-0.4px',
    tighter: '-0.8px',
    wide: '0.4px',
    wider: '0.8px',
    widest: '1.6px',
  },
  lineHeight: {
    'x100-use-100': '100px',
    'x125-use-125': '125px',
    'x138-use-138': '138px',
    'x150-use-150': '150px',
    'x200-use-200': '200px',
  },
  weight: {
    black: '900',
    bold: '700',
    extrabold: '800',
    extralight: '200',
    light: '300',
    medium: '500',
    regular: '400',
    semibold: '600',
    thin: '100',
  },
} as const
